"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _agent = require("@deosite/agent");
var _createParametrizedUrl = _interopRequireDefault(require("@deosite/helpers/createParametrizedUrl"));
var _mapCategory = _interopRequireDefault(require("@deosite/helpers/mapCategory"));
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(categoryId, lang) {
    var categoryData;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (categoryId) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.next = 4;
            return _agent.requests.get((0, _createParametrizedUrl["default"])(global.__appConfig__.categoryUrl, {
              id: categoryId
            }), true, null, lang);
          case 4:
            categoryData = _context.sent;
            return _context.abrupt("return", (0, _mapCategory["default"])(categoryData));
          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fetcher(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;